/**
 * Intercambio de sesión (token+user en localStorage) durante una
 * impersonación. `POST /api/impersonations` sustituye la identidad activa
 * por la del suplantado; `DELETE /api/impersonations/current` solo cierra el
 * registro de auditoría en el backend, no devuelve un JWT nuevo — restaurar
 * la sesión del admin real es responsabilidad exclusiva del frontend, a
 * partir de la copia guardada aquí antes de impersonar.
 */
const BACKUP_KEY = "preImpersonationSession";

export const isImpersonating = () => !!localStorage.getItem(BACKUP_KEY);

export const saveOriginalSession = () => {
  localStorage.setItem(
    BACKUP_KEY,
    JSON.stringify({
      token: localStorage.getItem("token"),
      user: localStorage.getItem("user"),
    }),
  );
};

export const applyImpersonatedSession = (token, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
};

export const restoreOriginalSession = () => {
  const backup = localStorage.getItem(BACKUP_KEY);
  if (!backup) {
    return false;
  }

  const { token, user } = JSON.parse(backup);
  localStorage.setItem("token", token);
  localStorage.setItem("user", user);
  localStorage.removeItem(BACKUP_KEY);

  return true;
};
